import { View } from '../View/View';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledProgressBar = styled.div.withConfig({
  displayName: "ProgressBar__StyledProgressBar",
  componentId: "sc-10lejbe-0"
})(({
  $max,
  $min,
  $variant,
  $value,
  theme: _theme
}) => {
  const theme = _theme;
  const isInRange = $value > $min && $value < $max;
  return {
    alignItems: 'center',
    backgroundImage: (() => {
      switch ($variant) {
        case 'danger':
        case 'warning':
          return `linear-gradient(76deg, ${theme.color['fill-accent-light-orange-default']} 2%, ${theme.color['fill-accent-yellow-default']} 100%)`;
        case 'success':
        default:
          return `linear-gradient(76deg, ${theme.color['fill-positive-default']} 2%, ${theme.color['fill-info-default']} 100%)`;
      }
    })(),
    borderRadius: $variant !== 'danger' ? theme.borderRadius['100'] : undefined,
    borderRight: $variant === 'danger' && isInRange ? `3px ${theme.color['fill-surface-default']} solid` : undefined,
    color: theme.color['fill-surface-default'],
    display: 'flex',
    height: theme.size['icon-400'],
    justifyContent: 'center',
    transition: `width 0.6s easing`,
    width: `${Math.min(($value - $min) / ($max - $min), 1) * 100}%`
  };
});
export const ProgressBar = ({
  ariaLabel,
  descriptiveLabel,
  hasLabel = false,
  min = 0,
  max = 100,
  value = 0,
  valueLabel,
  variant = 'success'
}) => {
  const calculatedPercentage = Math.round(Math.min((value - min) / (max - min), 1) * 100);
  const renderedDescriptiveLabel = typeof descriptiveLabel === 'string' ? /*#__PURE__*/_jsx(Text, {
    typography: "body-200",
    children: descriptiveLabel
  }) : descriptiveLabel;
  const renderedValueLabel = !valueLabel || typeof valueLabel === 'string' ? /*#__PURE__*/_jsx(Text, {
    typography: "heading-100",
    children: valueLabel || `${calculatedPercentage}%`
  }) : valueLabel;
  return /*#__PURE__*/_jsxs(Flex, {
    role: "progressbar",
    rowGap: "200",
    flexDirection: "column",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: !descriptiveLabel ? 'end' : 'space-between',
      children: [renderedDescriptiveLabel, renderedValueLabel]
    }), /*#__PURE__*/_jsx(View, {
      backgroundColor: variant === 'danger' ? 'fill-alert-default' : 'fill-surface-raised',
      borderStartStartRadius: "100",
      borderStartEndRadius: "100",
      borderEndStartRadius: "100",
      borderEndEndRadius: "100",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(StyledProgressBar, {
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-label": ariaLabel,
        $value: value,
        $variant: variant,
        $min: min,
        $max: max,
        children: hasLabel ? /*#__PURE__*/_jsxs(Text, {
          typography: "detail-200",
          children: [calculatedPercentage, "%"]
        }) : null
      })
    })]
  });
};